<script setup>
import { Head, usePage } from '@inertiajs/vue3';
import Button from 'primevue/button';
import ApplicationLogo from '@/Components/ApplicationLogo.vue';

const page = usePage();

const order = page.props.order;
</script>

<template>
  <Head title="Confirmation de commande"/>

  <div class="min-h-full">
    <header class="pt-8 pb-4 flex justify-center">
      <a :href="route('order.form')">
        <ApplicationLogo class="w-72"/>
      </a>
    </header>

    <main
        class="relative max-w-2xl px-4 py-4 sm:px-6 lg:px-8 flex flex-col justify-center sm:items-center mx-auto size-full">
      <div class="text-center pb-4 px-4 sm:px-6 lg:px-8 size-full">
        <h1 class="text-xl sm:text-2xl text-primary uppercase font-semibold">
          Votre commande a bien été prise en compte
        </h1>

        <div class="mt-8 flex flex-col gap-4 text-gray-700">
          <p>
            Nous vous remercions pour votre commande.
          </p>

          <p v-if="order.status !== 'pending'">
            Un e-mail de confirmation vous a été envoyé avec les détails de votre achat.
          </p>
          
          <p v-else>
            Le paiement de votre commande est en attente de traitement, un e-mail de confirmation vous sera envoyé dès 
            qu'il sera validé.
          </p>

          <p class="font-semibold text-primary">
            Pour rappel :
          </p>

          <p>
            Une pièce d'identité sera exigée lors du retrait de vos chèques cadeaux.
          </p>

          <div>
            <p class="font-semibold">
              Les chèques sont à retirer aux jour et heure choisis à cette adresse :
            </p>
            <p>
              Conciergerie Mon Shopping C'est Calais
            </p>
            <p>
              6 Boulevard Jacquard
            </p>
            <p>
              62100 - Calais
            </p>
          </div>

          <p class="mt-4">
            <Button as="a" :href="route('order.pickup-slip', { key: order.pickup_slip_key })">
              Imprimer mon bon de retrait
            </Button>
          </p>

          <p class="mt-4">
            Merci de votre confiance, et à bientôt sur <nobr>Mon Shopping c'est Calais !</nobr>
          </p>
        </div>
      </div>
    </main>
  </div>
</template>
